/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { UtilService } from 'src/app/modules/cop/services/util.service';
import { DistanceService } from 'src/app/modules/core/services/distance/distance.service';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { DrawingToolsService } from '@app/modules/cop/drawing/drawing-tools.service';

const shapeMapping = {
  Point: 'Point',
  LineString: 'Line'
} as { [key: string]: string };
@Component({
  selector: 'app-geometry-field',
  templateUrl: './geometry-field.component.html',
  styleUrls: ['./geometry-field.component.scss'],
  standalone: false
})
export class GeometryFieldComponent implements DynamicField {
  @ViewChild('googleMap') googleMap: ElementRef;
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() document: Document;
  @Input() viewComponent: ViewComponent;
  @Input() dataset: Dataset;
  isReadOnly: boolean;

  @Input() schema: DocumentSchema;
  @Input() isEdit: boolean;
  isAdvancedEdit: boolean;
  set value(val: string) {
    if (!val) {
      val = '';
    }

    this._value = val;
    if (!val) {
      this.editValue = [];
      return;
    }
    let parsedObject = null as any;
    try {
      parsedObject = JSON.parse(val);
    } catch (e) {}

    // Unpack the geometry into the EditValue list of geometries
    this._unpackedValue = !parsedObject ? [] : this.utilService.unpackFeaturesForEditingToArrayFromGeoJson(parsedObject);

    this.editValue = this.getShapeList(this._unpackedValue);
    this.changeDetector.detectChanges();
  }
  get value(): string {
    if (!this._value) {
      this._value = null;
    }

    return this._value;
  }
  _value: string;
  _unpackedValue = [] as GeoJSON.Feature[];
  editValue = [] as { id: string; name: string }[];

  constructor(
    private distanceService: DistanceService,
    private utilService: UtilService,
    private mapDrawingTools: DrawingToolsService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  deleteItem(item: { id: string; name: string }) {
    this._unpackedValue = this._unpackedValue.filter(s => s.id !== item.id);
    this.editValue = this.getShapeList(this._unpackedValue);
    this._value = JSON.stringify(this.utilService.packFeaturesArrayAfterEditingIntoGeoJson(this._unpackedValue));

    const shapes = this.mapDrawingTools.getShapesForEdit();
    const idsToRemove = shapes.filter(feature => feature.properties.editingId === item.id).map(({ id }) => id?.toString());

    this.mapDrawingTools.removeShapes(idsToRemove);

    this.onValueChanged();
  }

  tpOnContentUpdated(): void {
    this.value = this.document?.[this.field.systemName];
    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
    }
  }

  getShapeList(_unpackedValue: GeoJSON.Feature[]): { id: string; name: string }[] {
    const countByTypeMap = {} as { [key: string]: number };
    if (!this._unpackedValue || this._unpackedValue.length === 0) {
      return [];
    }
    const mappedDeoDescription = this._unpackedValue.map(f => {
      let name = shapeMapping[f.geometry.type?.toString()] || f.geometry.type?.toString() || 'unknown';
      if (countByTypeMap[name] !== undefined) {
        countByTypeMap[name] = countByTypeMap[name] + 1;
        name = `${name}_${countByTypeMap[name]}`;
      }
      if (countByTypeMap[name] === undefined) {
        countByTypeMap[name] = 0;
      }
      return { id: f.id?.toString(), name };
    });
    return mappedDeoDescription;
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }
}
